import { LocalStorageEnum } from './storage.service';

/**
 * Invalidates the value in local storage for a given key,
 * if the value was created before invalidateBefore
 *
 * Side effects: Effects local storage.
 *
 * @param userEid The user profile's EID. Used to only invalidate options for this user.
 * @param invalidateBefore Milliseconds since the Epoch.
 */
export function invalidateLocalWidgetOptions(userEid: string, invalidateBefore: number) {
  const rawValue = localStorage.getItem(LocalStorageEnum.WidgetOptions);

  // bail if there are no widget options in local storage
  if (rawValue === null) {
    return;
  }

  const widgetOptions = JSON.parse(rawValue);

  // bail if there are no widget options for this user
  if (widgetOptions[userEid] === undefined) {
    return;
  }

  // prune this user's widget options if they were created before `invalidateBefore`
  const timestamp = widgetOptions[userEid].timestamp || 0;
  if (timestamp < invalidateBefore) {
    // prune this user's widget options
    delete widgetOptions[userEid];

    // save pruned options to local storage
    try {
      localStorage.setItem(LocalStorageEnum.WidgetOptions, JSON.stringify(widgetOptions));
    } catch {}
  }
}
